export default window.jQuery || window.Zepto;



// WEBPACK FOOTER //
// src/js/aui/jquery.js